<template>
  <div class="article-page-container">
    <SBackButton />
    <SArticle
      :title="title"
      :subTitle="subTitle"
      :content="content"
    />
  </div>
</template>

<script lang="ts">
import { getMetaInfo } from '@/utils/seo';

export default {
  name: 'ArticlePage',
  metaInfo() {
    return getMetaInfo((this as { cmsData?: { Seo?: unknown } }).cmsData?.Seo);
  },
};
</script>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import StrapiService from '@slg/web-customer-shared/src/services/StrapiService';
import SBackButton from '@slg/web-customer-shared/src/components/common/SBackButton.vue';
import SArticle from '@slg/web-customer-shared/src/components/common/SArticle.vue';
import { useCmsLocaleReload, useRouteRef } from '../../composables';

const route = useRouteRef();
const cmsData = ref<Record<string, any> | null>(null);

const title = computed(() => cmsData.value?.title || '');
const subTitle = computed(() => cmsData.value?.subTitle || '');
const content = computed(() => cmsData.value?.text || '');

async function loadCmsData() {
  try {
    const slug = route.value.params.name;
    const articleBySlug = await StrapiService.getArticleBySlug(slug);

    if (route.value.params.lang === articleBySlug.locale) {
      cmsData.value = articleBySlug;
    } else {
      const currentArticleLocalized = articleBySlug.localizations.find((item: { locale: string }) => item.locale === route.value.params.lang);

      if (currentArticleLocalized) {
        cmsData.value = await StrapiService.getArticleById(currentArticleLocalized.id);
      }
    }
  } catch (error) {
    cmsData.value = null;
  }
}

watch(() => route.value.params.name, () => {
  loadCmsData();
}, { deep: true, immediate: true });

useCmsLocaleReload(loadCmsData);
</script>

<style lang="scss">
.article-page-container {
  margin: 0 10%;
  padding: 30px;
  padding-top: 80px;
  min-height: 400px;
}
</style>
